import React, { Component } from 'react'
import axios from 'axios'
import sqlFormatter from "sql-formatter"
import { Alert, Container, FormGroup, FormTextarea, Row, Col, Button, Card, CardHeader} from "shards-react";
import { Form } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import PageTitle from "./../../components/common/PageTitle";
import auth from '../../components/common/Auth';
import history from '../../history';


const parentUrl = process.env.REACT_APP_RE_URL;


class EditCrud extends Component {

  constructor (props, context) {
    super(props, context)
    this.props = props;
    this.state = {
      loading: false,
      goToCruds: false,
      apiErr: null,
      formValidated: true,
    }
    this.data = {
      enabled: true,
    }
  }

  handleChange = (field, event) => {

    if (field === 'enabled') {
      this.setState({
        [field]: event.target.value === 'true'
      })
    } else {
      this.setState({
        [field]: event.target.value
      })
    }
  }


  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    var idCrud = this.props.idCrud;
    //const url = parentUrl + "/smre/1.0/entity_cruds/"+idCrud;

    const url = "http://carrito.singularmentor.com.ar/smre/1.0/entity_cruds/"+idCrud;
    const self = this;

    if (form.checkValidity() === false) {
      this.setState({
        formValidated: false,
      })
      return;
    }

    this.setState({
      loading: true
    })
    const token = auth.getAccessToken()

    const crud = {
        "id": this.state.id,
        "entity_id": this.state.id,
        "hash": this.state.hash,
        "crud_type" : this.state.crud_type,
        "crud_sql": this.state.crud_sql.replace(/\n|\t/g, ' ')
    }

    axios.put(
      url,
      crud,
      {headers: {"Authorization" : "Bearer "+token}
    })
    .then(function (response) {
      self.setState({
         loading: false,
         goToCruds: true
      })
    }).catch(function (error) {

      self.setState({
         apiErr: error.response ? (error.response.data.message ? error.response.data : error.response.data.error) : error,
         loading: false
      })
    });

  }

  componentDidMount () {
    this._getCrud()
  }

  _getCrud() {
    var idCrud = this.props.idCrud;
    const token = auth.getAccessToken()
    const url = parentUrl + "/smre/1.0/entity_cruds/"+idCrud;
    const self = this;

    axios.get(
      url,
      {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization" : "Bearer "+token
        }
      }
    ).then(function (response) {

      var crud = response.data.entity_cruds;

      self.setState({
      loading: false,
        id: crud.id,
        entity_id: crud.id,
        hash: crud.hash,
        crud_type: crud.crud_type,
        crud_sql :sqlFormatter.format(crud.crud_sql)
      })

    }).catch(function (error) {

      self.setState({
        loading: false,
        apiErr: error.response ? (error.response.data.message ? error.response.data : error.response.data.error) : error
      })

    });
  }

  goBack = () => {
    history.goBack();
  }

  render = () => {
    var idCrud = this.props.idCrud;

    // if(auth.isAuthenticated()){
        if (this.state.loading) {
          return (
            <div>
              <Container fluid>
                <br/>
                <div className="container center">
                    <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
                </div>
              </Container>
            </div>
          )
        }

        if (this.state.goToCruds){
            return <Redirect to={'/cruds/'+idCrud} />
        }

        let error
        if (this.state.apiErr) {
          error =  <Container fluid className="px-0"><Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}:  {this.state.apiErr.message}</Alert></Container>
        }

        return (
          <div>

            {error}

            <Container fluid>

              <Row noGutters className="page-header py-4">
                <PageTitle title={this.context.t('Cruds')} subtitle={this.context.t('Edit')} className="text-sm-left mb-3" />
              </Row>

              <Card small style={{ marginBottom: '20px'}}>
                <CardHeader className="border-bottom">
                  <h5 className="m-0">
                      <i className="material-icons blue-text md-24" style={{float: "left"}}>verified_user</i>
                      <span style={{float: "left", marginTop: "2px", marginLeft: "2px"}}>{this.state.crud_type}</span>
                  </h5>

                  <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "20px"}}  onClick={e => {this.goBack()}}>arrow_back</i>

                </CardHeader>
                <Form validate="true" onSubmit={e => this.handleSubmit(e)} style={{ padding: "10px"}}>
                    <Row>
                        <Col lg="12">
                            <Form.Group controlId='name'>
                              <FormGroup>
                                <FormTextarea style={{height: "220px"}} value={this.state.crud_sql} onChange={e => {this.handleChange('crud_sql', e)}} required/>
                              </FormGroup>
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr/>

                    <Button theme="primary" outline className="mb-2 mr-1" type='submit'>{this.context.t('Save')}</Button>
                    &nbsp;
                    <Button theme="secondary" outline className="mb-2 mr-1" onClick={this.goBack}>{this.context.t('Cancel')}</Button>
                  </Form>
              </Card>

            </Container>
          </div>
        )
    // }else{
    //     return <Redirect to='/' />
    // }
  }
}

EditCrud.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(EditCrud)
